import * as React from 'react';
import CenteredPageContainer from '../../../components/CenteredPageContainer';

const ThankYouPage = () => {
  return (
    <CenteredPageContainer>
      <div><h2>Thank you for signing up. We'll be in touch 🙂</h2></div>
    </CenteredPageContainer>
  );
};

export default ThankYouPage;



// WEBPACK FOOTER //
// ./src/pages/BecomeAHost/components/ThankYouPage.tsx